<template>
  <swiper class="swiper" :options="swiperOption">
    <swiper-slide v-for="work in works" :key="work.id">
      <router-link :to="{ path: `work/${medium}/${work.id}` }">
        <img :src="work.poster_source" :alt="work.title" class="poster" />
      </router-link>
    </swiper-slide>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
/* Swiper Component Documentation at https://swiperjs.com/swiper-api */
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "ListSwiper",

  components: { Swiper, SwiperSlide },

  props: {
    works: {
      type: Array,
      default: function () {
        return [];
      },
    },
    medium: String,
    breakpoints: {
      type: [Object, Boolean],
      default: false,
    },
  },

  data: function () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 5,
        freeMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-hidden",
        },
        mousewheel: true,
        breakpoints: this.breakpoints,
      },
    };
  },
};
</script>

<style scoped>
.poster {
  width: 200px;
}

.swiper-button-next,
.swiper-button-prev {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 100%;
  width: 40px;
  height: 50px;
}

.swiper-button-prev::after {
  transform: translateX(-4px);
}
.swiper-button-next::after {
  transform: translateX(4px);
}

.swiper-button-hidden {
  visibility: hidden;
}
</style>
